import { Link } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'
import type { Invoice } from '@/lib/invoice-types'

interface InvoiceEmailBannerProps {
  invoice: Invoice
}

export function InvoiceEmailBanner({ invoice }: InvoiceEmailBannerProps) {
  if (!invoice.missingInvoiceEmail) return null

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-card border border-status-overdue/30 bg-status-overdue/6 px-4 py-3 text-sm">
      <span className="inline-flex items-center gap-2 text-ink">
        <AlertTriangle className="h-4 w-4 text-status-overdue" aria-hidden />
        Geen factuur-e-mailadres bekend. Indienen en versturen lukt pas als dat is ingevuld.
      </span>
      <Link
        to="/klanten/$id"
        params={{ id: invoice.clientId }}
        className="ml-auto text-xs font-medium text-status-overdue"
      >
        Naar {invoice.clientName} →
      </Link>
    </div>
  )
}
